import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { create } from '../../services/upload-files.service';
import { addFacilities, start } from '../../store/slices/FacilitiesSlice';
import useFetch from '../../hooks/useFetch';
import { Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function AddNewReport(props) {

    const { data, isLoading } = useFetch(`facilities/profile/0`)

    return (

        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Choose a Report
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-sm-12">
                        <Row xs={1} md={2} className="g-4 popupcard">
                            {data && data.length > 0 ? data.map((val, idx) => (
                                <Col key={idx}>
                                    <Link to={
                                        val.sub_category === "GHG Emissions"
                                            ? "/reportform"
                                            : val.sub_category === "Air Quality"
                                                ? "/reportform"
                                                : val.sub_category === "Energy Management"
                                                    ? "/reportform"
                                                    : val.sub_category === "Water & Wastewater Management"
                                                        ? "/reportform"
                                                        : val.sub_category === "Waste & Hazardous Materials Management"
                                                            ? "/reportform"
                                                            : "/defaultLink"
                                    }
                                        state={{ id: val.id, subCategoryName: val.sub_category, displayName: val.display_name }}
                                    > <Card>
                                            <Card.Body>
                                                <div className="facility-inner-child">
                                                    <Card.Img variant="top" src="https://dummyimage.com/200x200/a19ca1/fff" />
                                                    <div className="facility-inner-child-content">
                                                        <span>{val.display_name} </span>
                                                        <span><b> {val.total_amount ? val.total_amount : ""}</b>{val.total_amount ? <small>kgCO2e</small> : ""}</span>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card></Link>
                                </Col>
                            )) : ""}
                        </Row>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddNewReport;